module.exports = __webpack_public_path__ + "img/3_128.f1f27ece.png";